import React from "react";
import PropTypes from "prop-types";
import { Feed, Icon, Button, Popup } from "semantic-ui-react";
import ModalComentarios from "../../../pages/shared/ModalComentarios";
import _ from "lodash";

function Incidencia(props) {
  const { incidencia } = props;
  return (
    <Feed.Event>
      <Feed.Label icon={incidencia.cerrada ? "lock" : "unlock"} />
      <Feed.Content>
        <Feed.Summary content={incidencia.comentario} />
        <Feed.Meta>
          <Icon name="unlock" />
          {`Abierta por ${incidencia.userName} el ${new Date(
            parseInt(incidencia.fecha, 10)
          ).toLocaleDateString()}`}
        </Feed.Meta>

        {!_.isEmpty(incidencia.userIDCierre) && (
          <Feed.Meta>
            <Icon name="lock" />
            {`Cerrada por ${incidencia.userNameCierre} el ${new Date(
              parseInt(incidencia.fechaCierre, 10)
            ).toLocaleDateString()}`}
          </Feed.Meta>
        )}
        <Feed.Extra>
          <Popup
            trigger={
              <Button
                disabled={incidencia.cerrada}
                circular
                color="green"
                icon="check"
                onClick={() => props.handleClick("cerrar", incidencia)}
              />
            }
            content="Cerrar Incidencia"
            basic
          />
          <Popup
            trigger={
              <ModalComentarios
                disabled={incidencia.cerrada}
                headerText={`Incidencia de ${props.nombreAlumno}`}
                color="grey"
                content={incidencia.comentario || null}
                itemID={incidencia.id}
                onSave={(id, texto) => props.handleClick("guardar", id, texto)}
                icon="pencil"
              />
            }
            content="Editar Incidencia"
            basic
          />
        </Feed.Extra>
      </Feed.Content>
    </Feed.Event>
  );
}

Incidencia.defaultProps = {
  incidencia: {},
  nombreAlumno: ""
};

Incidencia.propTypes = {
  incidencia: PropTypes.object,
  nombreAlumno: PropTypes.string,
  handleClick: PropTypes.func
};

export default Incidencia;



// WEBPACK FOOTER //
// ./src/pages/detalleAlumno/incidenciasAlumno/Incidencia.jsx